import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Chip,
  Stack,
  AppBar,
  Toolbar,
  Button,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  useScrollTrigger,
  Slide,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import axios from "axios";

// HideOnScroll for AppBar
const HideOnScroll = (props) => {
  const { children } = props;
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

const NAV_LINKS = [
  { label: "Home", path: "/user-home" },
  { label: "Albums", path: "/user-albums" },
  { label: "Frames", path: "/user-frames" },
  { label: "Photo Selection", path: "/user-photo-selection" },
  { label: "Prices", path: "/user-prices" }, // <-- Make sure this is present!
  { label: "Contact", path: "/user-contact" },
  { label: "About", path: "/user-about" }
];

const transition = (props) => <Slide direction="up" {...props} />;

const UserFrames = () => {
  const [frameData, setFrameData] = useState([]);
  const [footers, setFooters] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedFrameObj, setSelectedFrameObj] = useState(null); // for dialog content
  const [selectedFrames, setSelectedFrames] = useState({}); // for select/unselect state
  const clientMongoId = localStorage.getItem("clientMongoId");
  const userId = localStorage.getItem("userId");
  const isMobile = useMediaQuery("(max-width:600px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [frameselected, setFrameSelected] = useState([]);
  const studioName = localStorage.getItem("studioName") || "Studio";

  // Fetch frames data
  useEffect(() => {
    async function fetchFrames() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/frames`
        );
        setFrameData(res.data.frames || []);
      } catch (err) {
        setFrameData([]);
      }
    }
    fetchFrames();
  }, [clientMongoId]);

  // Fetch footers data
  useEffect(() => {
    async function fetchFooters() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`
        );
        setFooters(res.data.footers || {});
      } catch (err) {
        setFooters({});
      }
    }
    fetchFooters();
  }, [clientMongoId]);

  // Fetch selected frames for this user
  useEffect(() => {
    async function fetchSelected() {
      if (!clientMongoId || !userId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/users/${userId}/frameselected`
        );
        setFrameSelected(res.data.frameselected || []);
      } catch {
        setFrameSelected([]);
      }
    }
    fetchSelected();
  }, [clientMongoId, userId]);

  const handleCardClick = (frame) => {
    setSelectedFrameObj(frame);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedFrameObj(null);
  };

  // Select/Unselect handler for a frame
  const handleToggleSelectFrame = async (frameTitle) => {
    let updated;
    if (frameselected.includes(frameTitle)) {
      // Unselect: remove from array
      updated = frameselected.filter(f => f !== frameTitle);
    } else {
      // Select: add to array
      updated = [...frameselected, frameTitle];
    }
    setFrameSelected(updated);
    // Update in DB for this user
    await axios.put(
      `https://studio-lc.onrender.com/api/clients/${clientMongoId}/users/${userId}/frameselected`,
      { frameselected: updated }
    );
  };

  return (
    <Box
          sx={{
            bgcolor: "#fff",
            minHeight: "100vh",
            width: "100%",
            overflowX: "hidden",mt:2
          }}
        >
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#fff",
            boxShadow: 3,
            height: isMobile ? 56 : 80,
            zIndex: 1201
          }}
        >
          <Toolbar
            sx={{
              minHeight: isMobile ? 56 : 80,
              px: isMobile ? 1 : 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: isMobile ? "space-between" : "center"
            }}
          >
            <Typography
              variant={isMobile ? "h5" : "h4"}
              sx={{
                
                fontWeight: 1000,
                color: "#8b5e3c",
                fontFamily: "josefin Sans",
                letterSpacing: 2,
                mr: isMobile ? 0 : 4,
                flexShrink: 0
              }}
            >
              {studioName}
            </Typography>
            {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 4,
                  flexGrow: 1,
                  
                }}
              >
                {NAV_LINKS.map((link) => (
                  <Button
                    key={link.label}
                    href={link.path}
                    sx={{
                      color: "#8b5e3c",
                      fontWeight: 1000,
                       fontFamily: "josefin Sans",
                      fontSize: 22,
                      textTransform: "none",
                      letterSpacing: 1.5
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}
            {isMobile && (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ ml: "auto" }}
              >
                <MenuIcon sx={{ color: "#8b5e3c", fontSize: 36,fontFamily: "josefin Sans", }} />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 220, mt: 6 }}>
          <List>
            {NAV_LINKS.map((link) => (
              <ListItem
                button
                key={link.label}
                component="a"
                href={link.path}
                onClick={() => setDrawerOpen(false)}
              >
                <ListItemText
                  primary={link.label}
                  primaryTypographyProps={{
                    fontSize: 20,
                    fontWeight: 600,
                    fontFamily: "josefin Sans",
                    
                    color: "#8b5e3c"
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <Box sx={{ height: isMobile ? 56 : 80 }} />
      <Typography
        variant="h3"
        sx={{
          display: "inline-block",
          textAlign: "center",
          fontWeight: 700,
          mb: 4,
          width: "100%", // Use 100% instead of 94%
          color: "#8b5e3c",
          letterSpacing: 2,
          background: "linear-gradient(90deg, #fff8e1 60%, #ffe0b2 100%)",
          px: 2,
          py: 1.5,
          borderRadius: 6,
          boxShadow: "0 2px 12px 0 rgba(194, 155, 99, 0.10)",
          mx: "auto",
        fontFamily: "josefin Sans",
        }}
      >
        Frames
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {frameData.map((frame, idx) => (
          <Grid item xs={12} sm={6} md={4} key={frame.title + idx}>
            <Card
              sx={{
                width: 380,           // Fixed width
                minWidth: 350,
                maxWidth: 380,
                borderRadius: 6,
                background: "linear-gradient(135deg, #fff, #fff8e1 60%, #fbe9e7 100%)",
                border: "1.5px solid #f5e1c1",
                boxShadow: "0 8px 32px rgba(194, 155, 99, 0.13)",
                transition: "box-shadow 0.3s, transform 0.3s",
                "&:hover": {
                  boxShadow: "0 16px 40px rgba(194, 155, 99, 0.22)",
                  transform: "scale(1.045)"
                },
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
              }}
            >
              <CardActionArea onClick={() => handleCardClick(frame)}>
                <CardMedia
                  component="img"
                  height="200"
                  image={frame.img}
                  alt={frame.title}
                  sx={{
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    animation: "albumFade 2s"
                  }}
                />
                <CardContent
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    minHeight: 0,
                    overflow: "hidden",
                    pb: "0 !important"
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 1 }}>
                    <Chip
                      label={frame.category || frame.style || "N/A"}
                      variant="outlined"
                      sx={{
                        background: "#8b5e3c",
                        color: "#fff",
                        fontWeight: 700,
                        fontFamily: "Josefin Sans",
                        fontSize: 15,
                        px: 2,
                        borderRadius: 5,
                        letterSpacing: 0.5,
                        maxWidth: 120,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    />
                  </Box>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      color: "#a67c52",
                      textAlign: "center",
                      fontFamily: "Josefin Sans"
                    }}
                  >
                    {frame.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontWeight: 500,
                      mb: 1,
                      color: "#8b5e3c",
                      fontFamily: "Jost",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      maxWidth: "100%",
                      fontSize: 16,
                      lineHeight: 1.5,
                      maxHeight: 48, // About 2-3 lines
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical"
                    }}
                  >
                    {frame.desc}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      textAlign: "center",
                      color: "#a67c52",
                      fontWeight: 700,
                      fontSize: 16,
                      fontFamily: "Josefin Sans"
                    }}
                  >
                    {frame.price}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <Button
                sx={{
                  mt: 1,
                  fontWeight: 700,
                  borderRadius: 3,
                  letterSpacing: 1,
                  fontSize: 10,
                  width: "30%",
                  ml: "35%",
                  mb: 2,
                  fontFamily: "Jost",
                  color: "#fff",
                  background: "#8b5e3c",
                  "&:hover": { background: "#a67c52" }
                }}
                onClick={e => {
                  e.stopPropagation();
                  handleCardClick(frame);
                }}
              >
                More Info
              </Button>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Footer Section */}
      {/* Footer Section */}
          <Box
                 sx={{
                   bgcolor: "#a67c52",
                   color: "#fff",
                    fontFamily: "Josefin Sans",
                   mt: 4,
                   pt: 4,
                   pb: 2
                 }}
               >
                 <Grid container spacing={2} sx={{ maxWidth: 1300, mx: "auto" }}>
                   {/* Left Column */}
                   <Grid item xs={12} md={3} sx={{ml: { xs: 3 }, mt: { xs: 6,  }}}>
                     <Typography variant="h5" sx={{ fontWeight: 700,  fontFamily: "Josefin Sans",  }}>
                       {footers.studio}
                     </Typography>
                     <Typography variant="body1" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.tag}</Typography>
                     <Typography variant="body2" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.handle}</Typography>
                   </Grid>
                   {/* Center Column */}
                   <Grid
                     item
                     xs={12}
                     md={6}
                     sx={{
                       display: "flex",
                       flexDirection: "column",
                       alignItems: "center",
                       justifyContent: "center",
                       ml: { xs: 0, md: 12 }
                     }}
                   >
                     <Typography
                       variant="body1"
                       sx={{
                         textAlign: "center",
                         fontSize: 18,
                         mb: 2,
                         fontFamily: "Jost",
                       }}
                     >
                       {footers.text}
                     </Typography>
                   </Grid>
                   {/* Right Column */}
                   <Grid item xs={12} md={3}>
                     <Box sx={{ display: "flex", gap: 2, mb: 2,ml: { xs: 3, md: 15 } ,mt: { xs: 6, md: 5 } }}>
                       {/* WhatsApp */}
                       <a href="https://wa.me/919123456789" target="_blank" rel="noopener noreferrer">
                         <Box sx={{ bgcolor: "#25D366", borderRadius: "50%", p: 1 }}>
                           <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: 28, height: 28 }} />
                         </Box>
                       </a>
                       {/* Instagram */}
                       <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                         <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                           <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: 28, height: 28 }} />
                         </Box>
                       </a>
                       {/* Gmail */}
                       <a href="mailto:studioartmdu@gmail.com" target="_blank" rel="noopener noreferrer">
                         <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                           <img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Gmail" style={{ width: 28, height: 28 }} />
                         </Box>
                       </a>
                       {/* YouTube */}
                       <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                         <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                           <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 28, height: 28 }} />
                         </Box>
                       </a>
                     </Box>
                   </Grid>
                   {/* Bottom Row */}
                   <Grid
                     item
                     xs={12}
                     sx={{
                       borderTop: "1px solid #fff2",
                       mt: 0,
                       ml: {xs:5, md:50},
                       pt: 2,
                       display: "flex",
                       flexDirection: { xs: "column", md: "row" },
                       justifyContent: "space-between",
                       alignItems: "center"
                     }}
                   >
                     <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                       {footers.copyright}
                     </Typography>
                     <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                       {footers.made}
                     </Typography>
                   </Grid>
                 </Grid>
               </Box>
      {/* Animation styles */}
      <style>
        {`
          @keyframes albumFade {
            0% { opacity: 0; transform: scale(0.96);}
            100% { opacity: 1; transform: scale(1);}
          }
          @keyframes frameDialogFade {
            0% { opacity: 0; transform: translateY(20px);}
            100% { opacity: 1; transform: translateY(0);}
          }
          @keyframes frameFade {
            0% { opacity: 0; transform: scale(0.96);}
            100% { opacity: 1; transform: scale(1);}
          }
        `}
      </style>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={transition}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 8,
            bgcolor: "#fff",
            animation: "frameDialogFade 1s"
          }
        }}
      >
        {selectedFrameObj && (
          <>
            <DialogTitle
              sx={{
                fontWeight: 700,
                color: "#a67c52",
                textAlign: "center",
                fontSize: 28,
                 fontFamily: "Josefin Sans",
                letterSpacing: 2
              }}
            >
              {selectedFrameObj.title}
            </DialogTitle>
            <DialogContent>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img
                  src={selectedFrameObj.img}
                  alt={selectedFrameObj.title}
                  style={{
                    width: "100%",
                    maxWidth: 320,
                    height: 180,
                    objectFit: "cover",
                    borderRadius: 12,
                    marginBottom: 16,
                    boxShadow: "0 4px 16px rgba(166, 124, 82, 0.10)",
                    animation: "frameFade 2s"
                  }}
                />
                <Chip sx={{background:"#8b5e3c",color:"#fff", fontFamily:"Josefin Sans", mb:2}} label={selectedFrameObj.category || selectedFrameObj.style} variant="outlined"  />
                <Typography
                  variant="body1"
                  sx={{
                    color: "#8b5e3c",
                    fontFamily:"jost",
                    fontWeight: 500,
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    mb: 2,
                    fontSize: 18
                  }}
                >
                  {selectedFrameObj.details || selectedFrameObj.desc}
                </Typography>
                {selectedFrameObj && (
                  <Button
                    onClick={() => handleToggleSelectFrame(selectedFrameObj.title)}
                    sx={{
                      mt: 2,
                      width: "40%",
                      fontWeight: 700,
                      fontSize: 17,
                      letterSpacing: 1,
                      borderRadius: 3,
                      boxShadow: frameselected.includes(selectedFrameObj.title)
                        ? "0 4px 16px #43ea7b33"
                        : "0 4px 16px #1976d233",
                      background: frameselected.includes(selectedFrameObj.title)
                        ? "linear-gradient(90deg,#43ea7b 0%,#1de9b6 100%)"
                        : "linear-gradient(90deg,#fff 0%,#e3f2fd 100%)",
                      color: frameselected.includes(selectedFrameObj.title) ? "#fff" : "#1976d2",
                      border: frameselected.includes(selectedFrameObj.title)
                        ? "2px solid #43ea7b"
                        : "2px solid #1976d2",
                      transition: "all 0.2s",
                      "&:hover": {
                        background: frameselected.includes(selectedFrameObj.title)
                          ? "linear-gradient(90deg,#00bfa5 0%,#43ea7b 100%)"
                          : "linear-gradient(90deg,#e3f2fd 0%,#fff 100%)",
                        color: frameselected.includes(selectedFrameObj.title) ? "#fff" : "#1976d2",
                        boxShadow: 6,
                        transform: "scale(1.05)"
                      }
                    }}
                  >
                    {frameselected.includes(selectedFrameObj.title) ? "Unselect" : "Select"}
                  </Button>
                )}
              </Box>
            </DialogContent>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default UserFrames;